import React from 'react';
import ResponsiveMenu from '../responsive-menu';
import './index.css';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <ResponsiveMenu />
      <main className="layout-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
